import { useState } from "react";
import { showSuccessToast, showErrorToast } from "utils/toast";
import { downloadBillingReport } from "app/services/billingReport/billing";
import { downloadFile } from "app/utils/file";

const useBillingReportForm = ({ onClose }) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadBillingReportData = async (values) => {
    try {
      setIsDownloading(true);
      const response = await downloadBillingReport({
        startDate: values.startDate,
        endDate: values.endDate,
      });

      const { data, filename, count } = response || {};

      if (count > 0) {
        downloadFile({ data }, filename);
        showSuccessToast("Billing Report downloaded successfully.");
        onClose();
      } else {
        showSuccessToast("No data found for the selected date range.");
      }
    } catch (error) {
      showErrorToast(error.message || "Failed to download billing report");
    } finally {
      setIsDownloading(false);
    }
  };

  return {
    isDownloading,
    downloadBillingReportData,
  };
};

export default useBillingReportForm;
